import React from 'react';
import PropTypes from 'prop-types';
import { notificationTypes } from 'lib/notificationTypes';

const Alert = ({ type, title, message, showCloseButton, onClose }) => {
  const styles = notificationTypes[type] || notificationTypes.info;

  return (
    <div
      onClick={onClose}
      className={`flex items-center p-4 mb-4 text-sm ${styles.text} ${styles.border} border rounded-lg bg-gray-weakest cursor-pointer`}
      role="alert"
    >
      <i className={`${styles.icon} flex-shrink-0 w-4 h-4 me-3`} aria-hidden="true"></i>
      <div className="flex-grow">
        {title && <span className="font-medium">{title}</span>}
        {message && <span>{message}</span>}
      </div>
      {showCloseButton && (
        <button className="ml-3 text-gray-more hover:strong focus:outline-none" aria-label="Close">
          <i className="fas fa-times"></i>
        </button>
      )}
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(['info', 'danger', 'success', 'warning', 'dark']),
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func
};

Alert.defaultProps = {
  type: 'info',
  title: '',
  showCloseButton: true,
  onClose: () => { }
};

export default Alert;
